// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import BillingModalGenericBlocker from './BillingModalGenericBlocker'
import { useSubscription } from '../../../hooks/subscriptions/queries';
import { useCurrentUser } from '../../../hooks/users/queries';
import { isOwner } from '../../../utils/subscriptionUtils';

function BillingModalProjectBlocker({ onClick }) {
  const { data: subscription } = useSubscription();
  const { data: currentUser } = useCurrentUser();
  const isSubscriptionOwner = isOwner(subscription, currentUser?.id);
  
  const text = isSubscriptionOwner ?
    "Please renew your subscription to create a new project." :
    "Please start your subscription to create a new project."

  return (
    <BillingModalGenericBlocker
      onClick={onClick}
      text={text}
      header="Delve Subscription Required"
      isSubscriptionOwner={isSubscriptionOwner}
    />
  );
}

export default BillingModalProjectBlocker;